import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, ButtonDropdown, Checkbox, Container, FormField, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import SelectEquipment from '../../../../../components/selects/selectEquipment';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemEquipment } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, downloadFile, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import DPModal from '../../../../../components/DPModal';

interface DocItem {
  id: string;
  date: string;
  doc: string;
  url: string;
  type: string;
}

export const CMAEquipmentsOOFPage = () => {
  //const storeAdmin = useStoreAdmin();

  useGlobalState();
  const { menu, parameters } = useGlobalState();
  const [equipment, setEquipment] = useState<ItemEquipment>();
  const handleUpdateEquipment = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/update',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({
          idEquipment: parameters.idEquipment,
          isOutOfFlight: equipment?.isOutOfFlight,
          outOfFlightStart: equipment?.outOfFlightStart,
          outOfFlightEnd: equipment?.outOfFlightEnd
        })
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();

      addNotificationStatus(data, setData);
      if (data && data.equipment) {
        setEquipment(undefined);
        setParameters({ ...parameters, idEquipment: 0 });
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally {
      setLoading(false);
    }
  };
  const handleGetEquipment = async () => {
    try {
      if (!parameters.idEquipment || parameters.idEquipment == 0) return;
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/get',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({
          idEquipment: parameters.idEquipment,
          columns: "idEquipment, registration, make, model, isOutOfFlight, outOfFlightStart, outOfFlightEnd"
        })
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.equipment) {
        setEquipment(data.equipment)
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!parameters.idEquipment || parameters.idEquipment == 0) {
      setEquipment(undefined);
      return;
    }
    handleGetEquipment()

  }, [parameters.idEquipment]);



  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Documentación aeronaves</Header>
          <div style={{ width: 200 }}>
            <FormField label="Seleccione aeronave">
              <SelectEquipment isMant={1} isClub={1} onConfirm={(e) => {
                console.log(e)
                if (e) setParameters({ ...parameters, idEquipment: e.idEquipment });
                else setParameters({ ...parameters, idEquipment: 0 });
              }} value={parameters?.idEquipment || 0} />
            </FormField>
          </div>
          {!!equipment && (
            <Container
              footer={
                <Box float="right">
                  <Button variant="primary" onClick={async () => { handleUpdateEquipment() }}>Actualizar</Button>
                </Box>
              }
              header={<Header variant="h2"
                description={`${equipment?.make}-${equipment?.model}`}

                actions={
                  <Button variant="link" onClick={() => {
                    setParameters({ ...parameters, idEquipment: 0 });

                  }}>Cancelar</Button>
                }
              >Aeronave: {equipment?.registration}</Header>}>
              <Checkbox checked={equipment.isOutOfFlight === 1} onChange={(e) => {
                setEquipment({ ...equipment, isOutOfFlight: e.detail.checked ? 1 : 0 });
              }}>Fuera de vuelo</Checkbox>

              {equipment.isOutOfFlight === 1 && (
                <SpaceBetween size="s" direction="vertical">

                  <FormField label="Inicio del fuera de vuelo" constraintText="Opcional">
                    <DPModal date={equipment.outOfFlightStart} onConfirm={(e) => {
                      setEquipment({ ...equipment, outOfFlightStart: e });
                    }} />
                  </FormField>
                  <FormField label="Término del fuera de vuelo" constraintText="Opcional">
                    <DPModal date={equipment.outOfFlightEnd} onConfirm={(e) => {
                      setEquipment({ ...equipment, outOfFlightEnd: e });
                    }} />
                  </FormField>
                </SpaceBetween>


              )}


            </Container>
          )
          }
        </SpaceBetween >
      }
    />
  );
};
